// extracted by mini-css-extract-plugin
export default {"icon":"FilterMenu_icon__ZBLU0","redIcon":"FilterMenu_redIcon__6aK8P","badge":"FilterMenu_badge__ZswS0","dropdown":"FilterMenu_dropdown__W2XpC","pivot":"FilterMenu_pivot__-r9M6"};